<template>
    <div class="hidden"></div>
</template>

<script>
export default {
    props: {
        speed: {
            type: Number,
            default: 1000
        },
        every: {
            type: Number,
            required: true
        },
        repeat: {
            type: Number,
            required: false
        },
    },
    model: {
        event: ['times-up']
    },
    data() {
        return {
            lastResetTime: null,
            remainingRepetitions: null
        };
    },
    mounted() {
        this.lastResetTime = Date.now();
        this.remainingRepetitions = this.repeat;
        this.countdown();
    },
    methods: {
        countdown() {
            const nextTimesUp = this.lastResetTime + this.every * 1000;
            const now = Date.now();

            if (now > nextTimesUp) {
                this.$emit('times-up');
                this.lastResetTime = now;
                if (this.remainingRepetitions) {
                    this.remainingRepetitions--;
                }
            }

            if (this.remainingRepetitions === undefined || this.remainingRepetitions > 0) {
                setTimeout(this.countdown, this.speed);
            }
        }
    }
};
</script>